import store from "@/store";
import { $loaderService } from "@/plugins/ELoaderService";

const temCaixaAberto = async (to, from, next) => {
  let currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    await $loaderService.loadBasicDataIfNeeded();
  }

  currentUser = store.getters["Auth/user"];
  if (!currentUser) {
    next({ name: "login" });
  } else if (currentUser.roleName === "secretario-municipal-educacao") {
    next({ name: "colaboradores.pontos" });
  } else {
    const pontofiqColabRoles = [
      "monitor-onibus-escolar",
      "coordenador-patio",
      "coordenador-vigilancia",
      "porteiro",
      "profissional-apoio",
    ];
    if (pontofiqColabRoles.includes(currentUser.roleName)) {
      next({ name: "colaboradores.meusPontos" });
    }
  }
};

export default temCaixaAberto;
